import { DocumentDownload } from '@dreamstack/icons/src/icon-components/DocumentDownload'
import { assertPopulated } from '@dreamstack/payload/src/lib/assertPopulated'
import { NewsArticle } from '@dreamstack/payload/src/payload-types'
import Link from 'next/link'
import type { FunctionComponent } from 'react'

const baseLinkClasses =
  'font-semibold text-px-20 leading-px-30 flex items-center'
const computeLinkClasses = (white?: boolean) =>
  [
    white
      ? 'text-accentroWhite-full mt-px-6'
      : 'text-accentroAqua-full mt-px-32',
    baseLinkClasses,
  ].join(' ')

export const NewsArticleFile: FunctionComponent<
  React.PropsWithChildren<{
    file?: NewsArticle['file']
    whiteText?: boolean
  }>
> = ({ file, whiteText = false }) => {
  assertPopulated(file)
  if (!file || !file.url) return null
  return (
    <div className="w-full">
      <Link href={file.url} passHref legacyBehavior>
        <a target="_blank" className={computeLinkClasses(whiteText)}>
          <DocumentDownload className="pr-px-8 h-px-32 w-px-32 flex-shrink-0" />
          <span className="overflow-ellipsis overflow-hidden">
            {file.title}
          </span>
        </a>
      </Link>
    </div>
  )
}
